import React, { useEffect, useRef, useState } from "react";
//import { useDispatch } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import axiosInstance from "../../../utils/axiosInstance";
import { setUserData } from "../../../store/userSlice";
import Volume from "./Volume";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TrioResults from "./tp-result/TrioResults.jsx";
import PopUptrioResults from "./tp_plain_result/trap.jsx";
const RATE_VAL = "500,000";


const RESULT_MARKET_LABELS = {
  1: "21 - Yes",
  2: "3CJ (1,2,4) - Yes",
  3: "3CJ (J,Q,K) - Yes",
  4: "Two Red Only",
  5: "Two Black Only",
  6: "Two Even Only",
  7: "Two Odd Only"
};
const TOTAL_SECONDS = 30;

const TRIO_MARKETS = [
  {
    title: "MATCH ODDS",
    runners: [{ name: "21 - Yes", bKey: "b1", lKey: "l1", typeMain: 1 }]
  },
  {
    title: "3 CARD JUDGEMENT (1, 2, 4)",
    runners: [
      { name: "3CJ (1,2,4) - Yes", bKey: "b2", lKey: "l2", typeMain: 2 }
    ]
  },
  {
    title: "3 CARD JUDGEMENT (J, Q, K)",
    runners: [
      { name: "3CJ (J,Q,K) - Yes", bKey: "b3", lKey: "l3", typeMain: 3 }
    ]
  },
  {
    title: "COLOR",
    runners: [
      { name: "Two Red Only", bKey: "b4", lKey: "l4", typeMain: 4 },
      { name: "Two Black Only", bKey: "b5", lKey: "l5", typeMain: 5 }
    ]
  },
  {
    title: "ODD-EVEN",
    runners: [
      { name: "Two Even Only", bKey: "b6", lKey: "l6", typeMain: 6 },
      { name: "Two Odd Only", bKey: "b7", lKey: "l7", typeMain: 7 }
    ]
  }
];

const RUNNER_LABELS = {
  b1: "21 - Yes",
  l1: "21 - Yes",
  b2: "3CJ (1,2,4) - Yes",
  l2: "3CJ (1,2,4) - Yes",
  b3: "3CJ (J,Q,K) - Yes",
  l3: "3CJ (J,Q,K) - Yes",
  b4: "Two Red Only",
  l4: "Two Red Only",
  b5: "Two Black Only",
  l5: "Two Black Only",
  b6: "Two Even Only",
  l6: "Two Even Only",
  b7: "Two Odd Only",
  l7: "Two Odd Only"
};

function getCardImg(code, reveal) {
  const show =
    reveal &&
    code &&
    code !== "1" &&
    String(code).toUpperCase() !== "NOT AVAILABLE";
  return `/assets/images/cards/${show ? code : "1"}.svg`;
}

function resultBtnClass(val) {
  const s = String(val ?? "").toUpperCase();
  if (s === "1" || s === "Y" || s === "YES") return "result-yes";
  if (s === "0" || s === "N" || s === "NO") return "result-no";
  return "";
}

function resultBtnLabel(val) {
  const s = String(val ?? "").toUpperCase();
  if (s === "1" || s === "Y" || s === "YES") return "Y";
  if (s === "0" || s === "N" || s === "NO") return "N";
  return val != null && val !== "" ? String(val) : "-";
}

function resultCardImg(code) {
  return `/assets/images/cards/${code && code !== "1" ? code : "1"}.svg`;
}

function marketWinLabel(val) {
  const n = Number(val);
  if (n === 1) return "WINNER";
  if (n === 0) return "LOSER";
  return val != null && val !== "" ? String(val) : "-";
}

function getRunnerBook(books, typeMain, runnerIndex) {
  const row = books.find((b) => Number(b.typeMain) === Number(typeMain));
  if (!row) return null;

  //const pos = runnerIndex === 0 ? row.rnr1s : row.rnr2s;
  //if (pos == null || pos === "" || Number(pos) === 0) return null;
  console.log("row->", row);
  return row;
}

export default function Trio() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [open, setOpen] = useState(false);
  const [showRules, setShowRules] = useState(false);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [resultData, setResultData] = useState([]);
  const [resultList, setResultList] = useState([]);
  const [placedBets, setPlacedBets] = useState([]);
  const [books, setBooks] = useState([]);
  const [roundId, setRoundId] = useState("");
  const [lastStatus, setLastStatus] = useState(null);
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  const [ac1, setAc1] = useState("1");
  const [ac2, setAc2] = useState("1");
  const [ac3, setAc3] = useState("1");
  const [b1, setB1] = useState(0);
  const [l1, setL1] = useState(0);
  const [b2, setB2] = useState(0);
  const [l2, setL2] = useState(0);
  const [b3, setB3] = useState(0);
  const [l3, setL3] = useState(0);
  const [b4, setB4] = useState(0);
  const [l4, setL4] = useState(0);
  const [b5, setB5] = useState(0);
  const [l5, setL5] = useState(0);
  const [b6, setB6] = useState(0);
  const [l6, setL6] = useState(0);
  const [b7, setB7] = useState(0);
  const [l7, setL7] = useState(0);

  const localTimerRef = useRef(null);
  const flipTimerRef = useRef(null);
  const cardsSettleTimerRef = useRef(null);
  const revealStartedForRef = useRef(null);
  const [shownAc1, setShownAc1] = useState("1");
  const [shownAc2, setShownAc2] = useState("1");
  const [shownAc3, setShownAc3] = useState("1");
  const [cardsSettled, setCardsSettled] = useState(false);
  const [isNarrowViewport, setIsNarrowViewport] = useState(
    () => typeof window !== "undefined" && window.innerWidth <= 768
  );
  const useMobileBetSlip = isMobile || isNarrowViewport;
  const oddsMap = {
    b1,
    l1,
    b2,
    l2,
    b3,
    l3,
    b4,
    l4,
    b5,
    l5,
    b6,
    l6,
    b7,
    l7
  };

  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "trio_rate_virtual"
  });

  console.log("data->", data);
  let payload = data?.data?.data;
  if (Array.isArray(payload)) payload = payload[0];
  const payloadResult = data?.data?.result;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );

  const displayRunnerName = (rnr) => RUNNER_LABELS[rnr] || rnr;

  const showBetfairBetSlip = (bettype, teamname, odds, typemain) => {
    const nextPlaceBet = {
      amount: 0,
      catmid: "",
      round: "",
      market_type: "m",
      game_name: "trio_virtual",
      odds,
      teamname,
      bettype,
      selectRnr: teamname,
      marketVal: 1,
      game_type: 7,
      typemain
    };
    nextPlaceBet.catmid = payload?.cat_mid ?? roundId;
    nextPlaceBet.round = payload?.cat_mid ?? roundId;

    setPlaceBetObject(nextPlaceBet);
    setBetErrorMessage({});
    if (useMobileBetSlip) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;
    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );
      const messageObj = {
        status: Boolean(response.data?.status),
        message: response.data?.message ?? ""
      };
      if (messageObj.status) {
        setShowBetSlipPopup(false);
        setShowBetSlip(false);
        getPlacedBets();
        getBook();
      }
      setBetErrorMessage(messageObj);
    } catch (error) {
      if (error.response?.data?.status === false) {
        setBetErrorMessage({
          status: false,
          message: error.response.data.message
        });
      }
    }
  };

  useEffect(() => {
    if (!payload) return;
    if (data?.user) dispatch(setUserData(data.user));
    updateUserData(data?.user);
    setDisplayLoader(false);

    if (lastStatus !== payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
    }
    if (lastStatus !== payload.evt_status) setLastStatus(payload.evt_status);

    setB1(payload?.b1 ?? 0);
    setL1(payload?.l1 ?? 0);
    setB2(payload?.b2 ?? 0);
    setL2(payload?.l2 ?? 0);
    setB3(payload?.b3 ?? 0);
    setL3(payload?.l3 ?? 0);
    setB4(payload?.b4 ?? 0);
    setL4(payload?.l4 ?? 0);
    setB5(payload?.b5 ?? 0);
    setL5(payload?.l5 ?? 0);
    setB6(payload?.b6 ?? 0);
    setL6(payload?.l6 ?? 0);
    setB7(payload?.b7 ?? 0);
    setL7(payload?.l7 ?? 0);
    setAc1(payload?.ac1 ?? "1");
    setAc2(payload?.ac2 ?? "1");
    setAc3(payload?.ac3 ?? "1");
    setRoundId(payload?.cat_mid ?? payload?.evt_id ?? "");

    const sec = Number(payload?.left_time);
    if (!Number.isNaN(sec)) {
      setTimeLeft(sec);
    }

    clearInterval(localTimerRef.current);
    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => {
    if (!payloadResult || payloadResult === "") return;
    setResultList(payloadResult);
  }, [payloadResult]);

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
    return () => {
      clearInterval(localTimerRef.current);
      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
    };
  }, []);

  /* ================= SEQUENTIAL CARD REVEAL ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;

    if (payload.evt_status === "OPEN") {
      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
      revealStartedForRef.current = null;
      setShownAc1("1");
      setShownAc2("1");
      setShownAc3("1");
      setCardsSettled(false);
      return;
    }

    const status = String(payload.evt_status).toUpperCase();
    if (status !== "CLOSED") return;

    const c1 = payload?.ac1;
    const c2 = payload?.ac2;
    const c3 = payload?.ac3;

    // Wait until the first card is a real card value
    if (!c1 || c1 === "1") return;

    const roundKey = `${c1}|${c2}|${c3}`;
    if (revealStartedForRef.current === roundKey) return;
    revealStartedForRef.current = roundKey;

    clearTimeout(flipTimerRef.current);
    clearTimeout(cardsSettleTimerRef.current);
    setShownAc1("1");
    setShownAc2("1");
    setShownAc3("1");
    setCardsSettled(false);

    let cancelled = false;

    // Left → Center → Right, each 1000ms apart; green bg 1000ms after last flip
    function revealLeft() {
      if (cancelled) return;
      setShownAc1(c1);
      flipTimerRef.current = setTimeout(revealCenter, 1000);
    }
    function revealCenter() {
      if (cancelled) return;
      setShownAc2(c2);
      flipTimerRef.current = setTimeout(revealRight, 1000);
    }
    function revealRight() {
      if (cancelled) return;
      setShownAc3(c3);
      clearTimeout(cardsSettleTimerRef.current);
      cardsSettleTimerRef.current = setTimeout(() => {
        if (!cancelled) setCardsSettled(true);
      }, 1000);
    }

    flipTimerRef.current = setTimeout(revealLeft, 300);

    return () => {
      cancelled = true;
      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
    };
  }, [payload?.evt_status, payload?.ac1, payload?.ac2, payload?.ac3]);

  useEffect(() => {
    const onResize = () => setIsNarrowViewport(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (payload?.cat_mid && payload?.evt_status === "OPEN") {
      getPlacedBets();
      getBook();
    }
  }, [payload?.cat_mid, payload?.evt_status]);

  async function getBook() {
    if (!payload?.cat_mid) return;
    try {
      const res = await axiosInstance.post("/casino/get-book", {
        cat_mid: payload.cat_mid,
        gametype: "trio_virtual"
      });
      setBooks(Array.isArray(res.data) ? res.data : []);
    } catch {
      setBooks([]);
    }
  }

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    try {
      const res = await axiosInstance.post("/casino/get-placed-bets", {
        cat_mid: payload.cat_mid,
        gametype: "trio_virtual"
      });
      setPlacedBets(res.data || []);
    } catch {
      setPlacedBets([]);
    }
  }

  const fetchProfile = async () => {
    try {
      const { data: profile } = await axiosInstance.get("/profile");
      setProfileData(profile);
    } catch {
      /* optional */
    }
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const showResultDetail = async () => {
    try {
      const response = await axiosInstance.post("/teenpatti-results", {
        game_type: "trio_rate_virtual"
      });
      setResultData(response.data.results_list || []);
    } catch {
      setResultData([]);
    }
  };

  const activeTab = (tab) => {
    setActiveTabIndex(tab);
    if (tab === 2) showResultDetail();
  };

  const closeBetSlip = () => {
    setShowBetSlip(false);
    setBetErrorMessage({});
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  const cardRows = [
    { name: "Left", code: shownAc1 },
    { name: "Center", code: shownAc2 },
    { name: "Right", code: shownAc3 }
  ];

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div className="aviator-scope trio-scope player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div className="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content">
                        <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                          <div className="col-6 col-md-6 titlebarname inline-block Gameidcol mt-2">
                            <p>TRIO</p>
                          </div>
                          <div
                            className="col-6 col-md-6 inline-block Gameidcol text-right"
                            style={{ marginTop: "4px" }}
                          >
                            <div
                              role="group"
                              className="btn-group btn-group-sm mr-2"
                            >
                              <button
                                type="button"
                                className={
                                  activeTabIndex === 1
                                    ? "tablink btn btn-primary bbactive"
                                    : "tablink btn btn-primary"
                                }
                                onClick={() => activeTab(1)}
                              >
                                Game
                              </button>
                              <button
                                type="button"
                                className={
                                  activeTabIndex === 2
                                    ? "tablink btn btn-primary bbactive"
                                    : "tablink btn btn-primary"
                                }
                                onClick={() => activeTab(2)}
                              >
                                Results
                              </button>
                              <button
                                type="button"
                                className="tablink btn btn-primary"
                                onClick={() => setShowRules(true)}
                              >
                                Rules
                              </button>
                            </div>
                          </div>
                        </div>

                        {showRules && (
                          <div className="trio-rules-modal modal-overlay">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Market Rules</h5>
                                <button
                                  type="button"
                                  className="close"
                                  aria-label="Close"
                                  onClick={() => setShowRules(false)}
                                >
                                  <span aria-hidden="true">×</span>
                                </button>
                              </div>
                              <div
                                id="market-rules-text"
                                className="modal-body"
                              >
                                <center>
                                  <h1>
                                    <b>Trio</b>
                                  </h1>
                                  <h2>Rules and Regulations</h2>
                                  <hr />
                                  <div>
                                    <h3>
                                      <b>GAME OBJECTIVES</b>
                                    </h3>
                                    <p className="pt20">
                                      To predict whether the total score on the
                                      3 cards is greater than or equal to 21.
                                    </p>
                                  </div>
                                  <div>
                                    <h3>
                                      <b>GAME RULES</b>
                                    </h3>
                                    <p className="pt20">
                                      <b> Hands Dealt:</b> 1(3 cards)
                                    </p>
                                    <p className="pt20">
                                      <b>21 Yes wins:</b> If the total score of
                                      the cards dealt is ≥ 21
                                    </p>
                                    <p className="pt20">
                                      <b>21 NO wins </b>: If the total score of
                                      the cards dealt is &lt; 21
                                    </p>
                                    <h3>
                                      <b>Side Bets:</b>
                                    </h3>
                                    <p className="pt20">
                                      <b>3 Card Judgement (1,2,4):</b> Predict
                                      one or more cards out of the 3 would be A,
                                      2 or 4 of any suit.
                                    </p>
                                    <p className="pt20">
                                      <b>3 Card Judgement (J,Q,K):</b> Predict
                                      one or more cards out of the 3 would be J,
                                      Q or K of any suit.
                                    </p>
                                    <p className="pt20">
                                      <b>Two Red only:</b> Predict if there
                                      would be only 2 Red cards out of the 3
                                      cards drawn.
                                    </p>
                                    <p className="pt20">
                                      <b>Two Black only:</b> Predict if there
                                      would be only 2 Black cards out of the 3
                                      cards drawn.
                                    </p>
                                    <p className="pt20">
                                      <b>Two Odd only:</b> Predict if there
                                      would be only 2 Odd cards out of the 3
                                      cards drawn.
                                    </p>
                                    <p className="pt20">
                                      <b>Two Even only:</b> Predict if there
                                      would be only 2 Even cards out of the 3
                                      cards drawn.
                                    </p>
                                    <p className="pt20">
                                      <b>Points</b>
                                      A to 10: 1 to 10
                                      <br />J = 11, Q = 12, K = 13
                                    </p>
                                  </div>
                                  <div>
                                    <h3>PAYOUTS</h3>
                                    <p className="pt20">
                                      Payout as per the bet placed.
                                    </p>
                                    <table className="table table-bordered table-sm">
                                      <tbody>
                                        <tr>
                                          <th>21 Yes</th>
                                          <th>1 to 1.85</th>
                                        </tr>
                                        <tr>
                                          <th>
                                            3 Card Judgement (1,2,4) - Yes
                                          </th>
                                          <th>1 to 1.77</th>
                                        </tr>
                                        <tr>
                                          <th>3 Card Judgement (1,2,4) - No</th>
                                          <th>1 to 1.84</th>
                                        </tr>
                                        <tr>
                                          <th>
                                            3 Card Judgement (J,Q,K) – Yes
                                          </th>
                                          <th>1 to 1.77</th>
                                        </tr>
                                        <tr>
                                          <th>3 Card Judgement (J,Q,K) – No</th>
                                          <th>1 to 1.84</th>
                                        </tr>
                                        <tr>
                                          <th>2 Red Only</th>
                                          <th>1 to 2.56</th>
                                        </tr>
                                        <tr>
                                          <th>2 Black Only</th>
                                          <th>1 to 2.56</th>
                                        </tr>
                                        <tr>
                                          <th>2 Odd Only</th>
                                          <th>1 to 2.39</th>
                                        </tr>
                                        <tr>
                                          <th>2 Even Only</th>
                                          <th>1 to 2.8</th>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </center>
                              </div>
                            </div>
                          </div>
                        )}

                        {activeTabIndex === 1 && payload && (
                          <>
                            <div
                              className="cards-layout blackjack"
                              style={{ position: "relative" }}
                            >
                              <div className="col-12 timerDiv2 mb-negative-24">
                                <div className="row mt-2 align-items-center timer-row">
                                  <div className="col-auto">
                                    <div className="Connectedclients">
                                      <i
                                        className="fa fa-user mr-1"
                                        aria-hidden="true"
                                        style={{
                                          fontSize: "14px",
                                          color: "white"
                                        }}
                                      />
                                      <b>
                                        <span className="number">1</span>
                                      </b>
                                    </div>
                                  </div>
                                  <div className="col-auto ms-auto timer-col">
                                    <div className="teenpatti-base-timer">
                                      <svg
                                        viewBox="0 0 100 100"
                                        className="base-timer__svg"
                                      >
                                        <g className="base-timer__circle">
                                          <circle
                                            cx="50"
                                            cy="50"
                                            r="45"
                                            className="base-timer__path-elapsed"
                                          />
                                          <path
                                            strokeDasharray={`${Math.round(
                                              dash
                                            )} ${Math.round(CIRC)}`}
                                            className={`base-timer__path-remaining ${timerColor}`}
                                            d="M 50, 50 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0"
                                          />
                                        </g>
                                      </svg>
                                      <span className="base-timer__label">
                                        {timeLeft <= 1 ? 0 : timeLeft}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="three-cards-wrapper">
                                {cardRows.map((card) => (
                                  <div
                                    className="player-containerHC"
                                    key={card.name}
                                  >
                                    <div className="player-itemHC">
                                      <span className="player-nameHC">
                                        {card.name}
                                      </span>
                                      <div className="player-cardHC">
                                        <div
                                          id="BFBCardFanView"
                                          className="card-viewHC"
                                        >
                                          <img
                                            src={getCardImg(card.code, true)}
                                            draggable={false}
                                            alt=""
                                            className="animate__animated animate__flipInY"
                                            key={card.code}
                                            style={{
                                              width: isMobile ? "46px" : "70px",
                                              height: isMobile ? "55px" : "85px"
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>

                              <Volume
                                id="TrioSoundcontrol"
                                style={{
                                  position: "absolute",
                                  right: 8,
                                  bottom: 8,
                                  zIndex: 100
                                }}
                              />
                            </div>

                            <center>
                              <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                                <div className="buttons-div">
                                  {Object.keys(resultList).map((idx) => (
                                    <button
                                      key={idx}
                                      type="button"
                                      className={`video-button border-gradient-btn border-gradient-purple-btn ${resultBtnClass(
                                        resultList[idx]
                                      )}`}
                                    >
                                      {resultBtnLabel(resultList[idx])}
                                    </button>
                                  ))}
                                </div>
                                <div className="round-div">
                                  <div className="label">Round ID:</div>
                                  <div className="id">{roundId}</div>
                                </div>
                              </div>
                            </center>

                            <div className="bg-white">
                              {TRIO_MARKETS.map((market, mi) => (
                                <div key={market.title}>
                                  <div
                                    className="tb-content"
                                    style={{ background: "#fff" }}
                                  >
                                    <div className="market-titlebar">
                                      <p className="market-name">
                                        <span className="market-name-badge">
                                          <i className="market-name-icon">
                                            <img
                                              src="/assets/images/time-img.png"
                                              alt=""
                                              style={{
                                                filter: "invert(100%)",
                                                marginTop: "-8px",
                                                marginLeft: "-1px"
                                              }}
                                            />
                                          </i>
                                          <span>{market.title} </span>
                                        </span>
                                      </p>
                                      <div className="market-overarround">
                                        <span />
                                        <strong>Back</strong>
                                      </div>
                                      <div className="market-overarround market-overarround-lay">
                                        <strong>Lay</strong>
                                      </div>
                                    </div>
                                    <div className="market-runners">
                                      {market.runners.map((runner, ri) => {
                                        const bookVal = getRunnerBook(
                                          books,
                                          runner.typeMain,
                                          ri
                                        );
                                        const backOdds =
                                          oddsMap[runner.bKey] ?? 0;
                                        const layOdds =
                                          oddsMap[runner.lKey] ?? 0;
                                        const winnerFields = {
                                          2: "one24",
                                          3: "jqk",
                                          4: "twoRed",
                                          5: "twoBlack",
                                          6: "twoEvenNumber",
                                          7: "twoOddNumber"
                                        };

                                        const isWinner =
                                          cardsSettled &&
                                          (
                                            runner.typeMain === 1
                                              ? Number(payload?.result) >= 21
                                              : Number(payload?.[winnerFields[runner.typeMain]]) === 1
                                          );
                                        return (
                                          <div
                                            key={runner.name}
                                            className="runner-runner"
                                            style={{ height: "auto" }}
                                          >
                                            <h3
                                              className={
                                                isWinner
                                                  ? "runner-name sussesBg"
                                                  : "runner-name"
                                              }
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontWeight:
                                                                "bold",
                                                              fontSize: "16px"
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            {runner.name}
                                                          </h4>
                                                        </td>
                                                      </tr>

                                                      {bookVal != null && (
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontWeight: 600
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                color:
                                                                  bookVal?.rnr1s >
                                                                    0
                                                                    ? "green"
                                                                    : "red"
                                                              }}
                                                            >
                                                              {bookVal?.rnr1s}
                                                            </span>
                                                            /
                                                            <span
                                                              style={{
                                                                color:
                                                                  bookVal?.rnr2s >
                                                                    0
                                                                    ? "green"
                                                                    : "red"
                                                              }}
                                                            >
                                                              {bookVal?.rnr2s}
                                                            </span>
                                                          </td>
                                                        </tr>
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              {isSuspended && (
                                                <div className="runner-disabled2">
                                                  {suspendedText}
                                                </div>
                                              )}
                                              <a className="price-price price-back whtBack">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    runner.name,
                                                    backOdds,
                                                    runner.typeMain
                                                  )
                                                }
                                              >
                                                <span className="price-odd">
                                                  {backOdds || ""}
                                                </span>
                                                <span className="price-amount">
                                                  {stakeLimit}
                                                </span>
                                              </a>
                                              <a
                                                className="price-price price-lay mb-show span1details"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "l",
                                                    runner.name,
                                                    layOdds,
                                                    runner.typeMain
                                                  )
                                                }
                                              >
                                                <span className="price-odd">
                                                  {layOdds || ""}
                                                </span>
                                                <span className="price-amount">
                                                  {stakeLimit}
                                                </span>
                                              </a>
                                              <a className="price-price price-lay whtBack">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack">
                                                <div>&nbsp;</div>
                                              </a>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                  {mi < TRIO_MARKETS.length - 1 && (
                                    <div
                                      style={{
                                        height: "5px",
                                        backgroundColor: "#000"
                                      }}
                                    />
                                  )}
                                </div>
                              ))}
                            </div>
                          </>
                        )}

                        {/*{activeTabIndex === 2 && (
                          <div
                            id="ResultsData"
                            className="tabcontent"
                            style={{ display: "block", color: "white" }}
                          >
                            <div className="left-content">
                              {resultData?.length > 0 ? (
                                resultData.map((dataObj, index) => {
                                  const cards = [
                                    { label: "Left", code: dataObj.ac1 },
                                    { label: "Center", code: dataObj.ac2 },
                                    { label: "Right", code: dataObj.ac3 }
                                  ];
                                  return (
                                    <div
                                      key={`${dataObj.evt_id}-${index}`}
                                      className="card"
                                      style={{
                                        border: "1px solid rgb(204, 204, 204)",
                                        borderRadius: "8px",
                                        padding: "10px",
                                        boxShadow:
                                          "rgba(0, 0, 0, 0.1) 0px 4px 8px",
                                        marginBottom: "5px",
                                        background:
                                          "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))",
                                        color: "white"
                                      }}
                                    >
                                      <div
                                        className="card-header"
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "16px",
                                          marginBottom: "5px",
                                          background: "transparent",
                                          borderBottom: "solid 1px #000"
                                        }}
                                      >
                                        {dataObj.evt_od} - (<b>Round Id = </b>
                                        {dataObj.evt_id ?? dataObj.cat_mid})
                                      </div>
                                      <div className="card-body">
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-evenly",
                                            flexWrap: "wrap",
                                            marginBottom: "10px"
                                          }}
                                        >
                                          {cards.map((card) => (
                                            <div
                                              key={card.label}
                                              style={{ textAlign: "center" }}
                                            >
                                              <div style={{ fontWeight: "bold" }}>
                                                {card.label}
                                              </div>
                                              <img
                                                src={resultCardImg(card.code)}
                                                alt=""
                                                loading="lazy"
                                                style={{
                                                  width: "40px",
                                                  height: "60px",
                                                  objectFit: "cover",
                                                  borderRadius: "5px"
                                                }}
                                              />
                                            </div>
                                          ))}
                                        </div>
                                        <table
                                          className="table table-sm"
                                          style={{ color: "#fff", marginBottom: 0 }}
                                        >
                                          <tbody>
                                            {[1, 2, 3, 4, 5, 6, 7].map((n) => {
                                              const val = dataObj[`result${n}`];
                                              const win = marketWinLabel(val);
                                              const bgCls =
                                                win === "WINNER"
                                                  ? "bgwinner"
                                                  : "bgLoser";
                                              return (
                                                <tr key={n}>
                                                  <td>
                                                    {RESULT_MARKET_LABELS[n]}
                                                  </td>
                                                  <td
                                                    className={`player-status ${bgCls}`}
                                                    style={{
                                                      fontWeight: "bold",
                                                      textAlign: "right"
                                                    }}
                                                  >
                                                    {win}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <p className="text-center mt-3">
                                  No results found.
                                </p>
                              )}
                            </div>
                          </div>
                        )}*/}
                      </div>
                      <div
                        style={{
                          display: activeTabIndex == 2 ? "" : "none",
                          color: "white"
                        }}
                      >
                        <TrioResults resultData={resultData} />
                      </div>
                    </div>

                    <div className="col-md-4 mobile-margin">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}
                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      />
                      <PopUptrioResults
                        resultsData={resultData}
                        catMid={payload?.cat_mid ?? roundId}
                        marketType={55}

                      />
                      <div className="bets">
                        <strong>
                          Matched Bets ({placedBets.length})
                          {!isConnected && (
                            <>
                              <img
                                src={reconnecting}
                                alt="dc"
                                className="rounded disconnected"
                              />{" "}
                              DISCONNECTED
                            </>
                          )}
                        </strong>
                        <div className="betting-table">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Runner</th>
                                <th>Price</th>
                                <th>Size</th>
                                <th />
                              </tr>
                            </thead>
                            <tbody>
                              {placedBets.map((bet, index) => {
                                const isBack =
                                  bet.type === "b" ||
                                  bet.side === "back" ||
                                  String(bet.rnr || "")
                                    .toLowerCase()
                                    .startsWith("b");
                                return (
                                  <tr
                                    key={index}
                                    className={isBack ? "back" : "lay"}
                                    style={{
                                      background:
                                        bet.type == "b" ? "#e9f6fc" : "#fce3e4"
                                    }}
                                  >
                                    <td>
                                      {displayRunnerName(bet.rnr)} - (
                                      {bet.cat_mid ?? roundId})
                                    </td>
                                    <td>{bet.rate}</td>
                                    <td>{bet.amnt}</td>
                                    <td />
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
      <style>{`
      @media (max-width: 768px) {
    .cards-layout.blackjack {
        min-height: unset !important;
    }
}
        @scope (.trio-scope) {
          .player-containerHC {
            display: inline-flex;
            flex-direction: column;
            margin: 5px;
          }
          .three-cards-wrapper {
            display: flex;
            justify-content: center;
            align-items: flex-start;
            gap: 1px;
            width: 100%;
            margin-top: 20px;
          }
          .volume-wrapper { margin-top: -25px; }
          .cards-layout.blackjack {
            position: relative;
            min-height: 210px;
            background: #000000 !important;
          }

          .cards-layout.blackjack::before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: radial-gradient(
              ellipse 100% 44% at 50% calc(30% + 40px),
              rgba(62, 193, 65, 0.95) 0%,
              rgba(62, 193, 65, 0.8) 15%,
              rgba(30, 80, 35, 0.5) 40%,
              #1e1e1e 55%,
              #1e1e1e 100%
            );
            opacity: 0.4;
            pointer-events: none;
            z-index: 0;
          }
          .cards-layout.blackjack > * {
            position: relative;
            z-index: 1;
          }
          .blackjack {
            background: #000000 !important;
          }
          .cards-layout.blackjack .sound-icon {
            right: 18px !important;
            transform: scale(0.9);
            transform-origin: center;
          }
          
          .timerDiv2 {
            padding-left: 5px;
            padding-top: 0;
            padding-right: 0;
            text-align: right;
          }
          .timerDiv2 .timer-row {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            width: 100%;
            margin-left: 0;
            margin-right: 0;
          }
          .timerDiv2 .timer-col {
            margin-left: auto;
            text-align: right;
            padding-right: 0;
          }
          .timerDiv2 .Connectedclients {
            position: relative;
            float: none;
            margin-top: -15px;
            margin-left: -2px;
          }
          .teenpatti-base-timer {
            position: relative;
            width: 50px;
          }
          .teenpatti-base-timer .base-timer__label {
            position: absolute;
            top: 0;
            left: 0;
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
            padding: 0;
            line-height: 1;
          }
          .bets .betting-table table tbody tr.back td {
            background-color: #e9f6fc !important;
          }
          .bets .betting-table table tbody tr.lay td {
            background-color: #fce3e4 !important;
          }
          .trio-rules-modal h1 {
            font-size: 40px;
            font-weight: 800;
          }
          .trio-rules-modal h3 { font-size: 28px; }
          .trio-rules-modal p {
            font-size: 15px;
            font-weight: 500;
          }
          .trio-rules-modal .modal-header {
            background-color: #fff;
            color: #000;
            padding: 1rem;
            display: flex;
            align-items: center;
            max-width: 100% !important;
            width: 100%;
          }
          .trio-rules-modal .modal-content {
            max-width: 800px;
            max-height: 100vh;
            margin-top: 25px;
            background-color: #fff;
            color: #000;
            border-radius: 8px;
            margin-left: auto;
            margin-right: auto;
            width: 100% !important;
          }
          .trio-rules-modal.modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: flex-start;
            z-index: 9999;
            overflow-y: auto;
          }
        }
        @media (min-width: 992px) {
          .trio-scope .row {
            margin-left: 0 !important;
            margin-right: 0 !important;
          }
        }
        @media (max-width: 576px) {
          .trio-scope .mobile-margin { margin-top: 8px; }
        }
        @media (max-width: 991px) {
          .trio-scope .col-md-4 > .modal.d-block {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 9999;
            margin: 0;
            background: rgba(0, 0, 0, 0.5);
          }
          .trio-scope .col-md-4 > .modal.d-block .modal-dialog {
            margin: 10px auto;
            max-width: 420px;
          }
        }
      `}</style>
    </div>
  );
}
